export default __webpack_public_path__ + "static/media/pic98.8695f021.jpg";